module.exports = __webpack_public_path__ + "static/img/v4-down_ios_active.c888898b.png";